export const FORMAT = {
    DATE: 'DD MMMM YYYY'
}

export const SCROLLER_OPTIONS = {
    duration: 200,
    delay: 0,
    smooth: true,
}

export const FORM_KEYS = {
    FREQUENCY: 'qvrb',
    RECURRING: 'dc5c8',
    ONCE: 'ajv5v',
    PAYMENT_METHOD: '73e9h',
    WIDGET_AMOUNT: '17avj',
    AMOUNT_25: 'btk0o',
    AMOUNT_50: '282rl',
    AMOUNT_75: '7qsuh',
    AMOUNT_OTHER: 'd6frt',
    CUSTOM_AMOUNT: '8oncl',
    ENTITY_TYPE: '73kvp',
    ENTITY_TYPE_COMPANY: 'e1er4',
    ENTITY_TYPE_PERSONAL: 'fknqi',
    ORGANIZATION: 'ft1h0',
    TITLE: '2b0q9',
    FIRST_NAME: 'd5f76',
    LAST_NAME: 'd1aer',
    CONTACT_FIRST_NAME: '701co',
    CONTACT_LAST_NAME: '7p032',
    EMAIL: '3g1b',
    PHONE_NUMBER: 'eh062',
    ADDRESS: '6cvjq',
    PARTNER_TITLE: '3cjh4',
    PARTNER_FIRST_NAME: 'cmgs',
    PARTNER_LAST_NAME: '5durq',
    STARSHIP_NEWS: '7o6sq',
    REASON: '9slpd',
    DONATION_MESSAGE: 'd28ps',
    REMEMBER: 'bi8o5'
}

export const CONSTANT = {
    RESPONSE_KEYS: 'response',
}